import "./solutions-grid-block.scss";